import React from 'react'
 
export default function PageUnderConstruction() {
  return (
	<div> 
		<img src={require('../../images/PageUnderConst.png').default} alt = "page is under construction" />
	</div> 
  )
}